module.exports = __webpack_public_path__ + "static/media/accordion_up.4a47bbe7.svg";